module.exports = __webpack_public_path__ + "static/media/dr-arthur-rubens.838c1b38.gif";